/**
 * Product image view switcher on the collection toolbar.
 *
 * Three views, one active at a time:
 *   product — image 1 (hover swaps to image 2)
 *   model   — image 3 (hover swaps to image 4)
 *   styled  — first image from the custom.see_it_styled_images metafield, no hover
 *
 * Every card already carries all three layers, so switching is only a class on
 * <body>. The choice is remembered so it survives filtering and navigation.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'flowar-product-view';
  var VIEWS = ['product', 'model', 'styled'];
  var CLASS_PREFIX = 'view-';

  function stored() {
    try {
      var v = window.localStorage.getItem(STORAGE_KEY);
      return VIEWS.indexOf(v) > -1 ? v : 'product';
    } catch (e) {
      return 'product';
    }
  }

  function remember(view) {
    try {
      window.localStorage.setItem(STORAGE_KEY, view);
    } catch (e) {
      /* Private browsing — still works for this page view. */
    }
  }

  function apply(view) {
    VIEWS.forEach(function (v) {
      document.body.classList.toggle(CLASS_PREFIX + v, v === view);
    });

    document.querySelectorAll('[data-view-set]').forEach(function (btn) {
      var on = btn.getAttribute('data-view-set') === view;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init() {
    if (!document.querySelector('[data-view-set]')) return;
    apply(stored());
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || typeof t.closest !== 'function') return;

    var btn = t.closest('[data-view-set]');
    if (!btn) return;

    evt.preventDefault();
    var view = btn.getAttribute('data-view-set');
    if (VIEWS.indexOf(view) === -1) return;

    apply(view);
    remember(view);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The collection grid re-renders on filter/sort without a full page load. */
  document.addEventListener('collection:reloaded', init);
  document.addEventListener('shopify:section:load', init);
})();
